<template>
  <v-row :style="{ backgroundColor: '#003478' }" class="lightning-panel d-flex">
    <v-col cols="12">
      <img
        style="width: 100%"
        alt=""
        v-if="publishType === 'FENTAN'"
        src="@/assets/image/banner.png"
      />
      <img
        style="width: 100%"
        alt=""
        v-if="publishType === 'QIANGGOU'"
        src="@/assets/image/banner.png"
      />
    </v-col>
    <v-col cols="12" class="l-content" style="margin-top: -150px">
      <div>
        <div class="text-center">
          <div class="l-title" v-if="state === 0">
            {{ $t("exchange.publishCountTxt0") }}
          </div>
          <div class="l-title" v-if="state === 1">
            {{ $t("exchange.publishCountTxt1") }}
          </div>
          <div class="l-title" v-if="state === 2">
            {{ $t("exchange.publishCountTxt2") }}
          </div>
          <div class="l-title" v-if="state === 3">
            {{ $t("exchange.publishCountTxt3") }}
          </div>
        </div>
        <div class="mt-12 d-flex justify-space-around">
          <div class="d-flex flex-column justify-center align-center">
            <span class="num">{{ day }}</span
            ><span class="txt">{{ $t("exchange.day") }}</span>
          </div>
          <div class="d-flex flex-column justify-center align-center">
            <span class="num">{{ hour }}</span
            ><span class="txt">{{ $t("exchange.hours") }}</span>
          </div>
          <div class="d-flex flex-column justify-center align-center">
            <span class="num">{{ minutes }}</span
            ><span class="txt">{{ $t("exchange.minutes") }}</span>
          </div>
          <div class="d-flex flex-column justify-center align-center">
            <span class="num">{{ seconds }}</span
            ><span class="txt">{{ $t("exchange.seconds") }}</span>
          </div>
        </div>
      </div>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: "preMarket",
  props: {
    countDownBgColor: {
      type: String
    },
    publishState: {
      type: Number,
      default: 0
    },
    publishType: {
      type: String,
      default: "NONE"
    },
    currentTime: {
      type: Number,
      default: 0
    },
    startTime: {
      type: String,
      default: "2000-01-01 00:00:00"
    },
    endTime: {
      type: String,
      default: "2000-01-01 00:00:00"
    },
    clearTime: {
      type: String,
      default: "2000-01-01 00:00:00"
    }
  },
  data() {
    return {
      currentT: 0,
      day: "00",
      hour: "00",
      minutes: "00",
      seconds: "00",
      timer: "",
      flag: false,
      state: 0 // 0: The event has not started 1: The event has started but not ended 2: The event has ended but not yet ended 3: The event has ended in liquidation
    };
  },

  mounted() {
    this.timer = setInterval(() => {
      if (this.flag) {
        clearInterval(this.timer);
      } else {
        this.timeDown();
      }
    }, 1000);
  },
  methods: {
    timeDown() {
      let endTime = 0;

      const nowTime = parseInt(this.currentT + this.currentTime);
      const startT = parseInt(new Date(this.startTime).getTime() / 1000);
      const endT = parseInt(new Date(this.endTime).getTime() / 1000);
      const clearT = parseInt(new Date(this.clearTime).getTime() / 1000);

      if (nowTime <= clearT) {
        this.state = 2;
        endTime = clearT;
      }
      if (nowTime <= endT) {
        this.state = 1;
        endTime = endT;
      }
      if (nowTime <= startT) {
        this.state = 0;
        endTime = startT;
      }

      let leftTime = endTime - nowTime;
      this.day = this.formate(parseInt(leftTime / (24 * 60 * 60)));
      this.hour = this.formate(parseInt((leftTime / (60 * 60)) % 24));
      this.minutes = this.formate(parseInt((leftTime / 60) % 60));
      this.seconds = this.formate(parseInt(leftTime % 60));
      if (this.state === 0) {
        // activity has not started
        // this.showPublishMask();
        this.$emit("update:countDownBgColor", "#003478");
        this.$emit("update:publishState", 0);
      }
      if (this.state === 1) {
        // activity is starting
        this.$emit("hidePublishMask");
        this.$emit("update:countDownBgColor", "#094802");
        this.$emit("update:publishState", 1);
      }
      if (this.state === 2) {
        // in liquidation
        this.$emit("showPublishMask");
        this.$emit("update:countDownBgColor", "#5b0000");
        this.$emit("update:publishState", 2);
      }
      if (this.state === 2 && leftTime <= 0) {
        // End of liquidation, normal trading
        this.$emit("hidePublishMask");
        this.$emit("hidePremarket");
        this.flag = true;
        this.state = 3;
        this.$emit("update:publishState", 3);
      }
      this.currentT = this.currentT + 1;
    },
    formate(time) {
      if (time >= 10) {
        return time;
      } else {
        return `0${time}`;
      }
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
};
</script>
<style scoped lang="scss">
.num {
  font-size: 20px;
  background: linear-gradient(0deg, #df9000, #ffb100);
  border-radius: 2px;
  color: #000;
  text-shadow: 1px 1px 1px #908e8e;
  min-width: 60px;
  padding: 5px 0;
}
.txt {
  font-size: 12px;
}

.lightning-panel .l-content .l-title {
  border: 1px solid rgb(176, 186, 194);
  padding: 3px 10px;
  color: #d3d9e1;
  display: inline-block;
  margin-top: 10px;
}

.lightning-panel .l-content .l-info {
  margin-top: 15px;
}
.lightning-panel .l-content .l-detail {
  margin-top: 10px;
  font-size: 10px;
  color: #29a6ff;
}
.lightning-panel .l-content .l-detail span:hover {
  color: #6bc0fd;
  cursor: pointer;
}
.lightning-panel .l-content .l-info .l-count {
  font-size: 14px;
}
.lightning-panel .l-content .l-info .l-txt {
  font-size: 12px;
}
.lightning-panel .l-content .l-info .l-txt:nth-child(2) {
  margin-left: 10px;
}
.lightning-panel .l-content .l-info .l-price {
  font-size: 14px;
}
.lightning-panel .l-content .l-info .l-unit {
  font-size: 8px;
}
</style>
